import fileApi from '../api/file'
import { responseType } from 'complex-require/src/Rule'

export const uploadFile = function(fileList: File[], code: string) {
  return new Promise((resolve, reject) => {
    const form = new FormData()
    fileList.forEach(file => {
      form.append('file', file)
    })
    form.append('bizType', code)
    fileApi.upload.require(form).then((res) => {
      const list = res.data.data
      resolve({
        file: list.map(item => {
          return {
            url: item.filePath,
            name: item.fileName,
            data: item
          }
        })
      })
    }).catch((err) => {
      reject(err)
    })
  })
}

export const saveFile = function(id: string, code: string, fileList: any[]) {
  return fileApi.save.require({
    relativeId: id,
    bizType: code,
    fileList: fileList
  })
}

export const getFile = function(id: string, code?: string): Promise<{ file: any[] }> {
  return new Promise((resolve, reject) => {
    fileApi.get.require({
      relativeId: id,
      bizType: code
    }).then((res) => {
      const list = res.data.data || []
      resolve({
        file: list.map(item => {
          return {
            url: item.filePath,
            name: item.fileName,
            data: item
          }
        })
      })
    }).catch((err) => {
      reject(err)
    })
  })
}

export const getFileWithPromise = function(promise: Promise<responseType>, id: string, code?: string): Promise<{ status: string, data: any, file?: any[] }> {
  return new Promise((resolve, reject) => {
    promise.then(res => {
      getFile(id, code).then((fileRes: any) => {
        resolve({ status: 'success', data: res.data.data, file: fileRes.file })
      }).catch(() => {
        resolve({ status: 'success', data: res.data.data })
      })
    }).catch(err => {
      reject(err)
    })
  })
}
